import { Component, Vue, Mixins } from 'vue-property-decorator';
import SBComponentVue from '@/components/SBComponentVue';
import { State } from 'vuex-class';
import { LoginStatus, PlanOrderHistoryPaymentMethodEnum } from '@/generated/api';
import { Action } from 'vuex-class';
import env from '@env'

@Component
export default class CommonView extends Mixins(SBComponentVue) {
    public env = env;

    @State('user')
    public loginStatus!: LoginStatus | null;

    public async isLoginRedirect(securitySafe: boolean): Promise<boolean> {
        if (!this.loginStatus) {
            // もしログインされてなければ再確認
            await this.getUserAPI();
        }

        // editinfo==true のとき、中間ログインだと再ログイン
        if (!this.loginStatus) {
            this.$router.replace("/mypage/login?url=" + this.$route.path);
            return true;
        }

        if (securitySafe && !this.loginStatus.securitySafe) {
            this.$router.replace("/mypage/login?url=" + this.$route.path);
            return true;
        }
        return false;
    }

    public async changeLanguage(): Promise<void> {
        await this.changeLanguageAPI();
    }

    @Action('getUserAPI')
    public getUserAPI!: () => Promise<void>;

    @Action('changeLanguageAPI')
    public changeLanguageAPI!: () => Promise<void>;

    public comma(value: number): string {
        return new Intl.NumberFormat('ja-JP', { style: 'decimal' }).format(value);
    }

}
